import Vue from 'vue'
export default ()=>{
    Vue.directive('noBlankSpace',{
        inserted: function (el) {
            let domInput;
            if(el.classList.contains('el-input')==true){
              domInput=el.childNodes.item(1)
            }else{
              domInput=el
            }
            // 中文等 IME 组字期间改写 value 会破坏组字，导致拼音与汉字叠在一起
            let composing = false
            const strip = function () {
              domInput.value = domInput.value.replace(/[, ]/g,'')
            }
            const onCompositionStart = function () {
              composing = true
            }
            const onCompositionEnd = function () {
              composing = false
              strip()
            }
            const onKeyup = function (e) {
              if (composing || e.isComposing) return
              strip()
            }
            domInput.addEventListener('compositionstart', onCompositionStart)
            domInput.addEventListener('compositionend', onCompositionEnd)
            domInput.addEventListener('keyup', onKeyup)
            el._noBlankSpaceCleanup = function () {
              domInput.removeEventListener('compositionstart', onCompositionStart)
              domInput.removeEventListener('compositionend', onCompositionEnd)
              domInput.removeEventListener('keyup', onKeyup)
              delete el._noBlankSpaceCleanup
            }
          },
        unbind: function (el) {
            if (typeof el._noBlankSpaceCleanup === 'function') {
              el._noBlankSpaceCleanup()
            }
          }
    })
}